import { Button, Popconfirm, Space, message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useEffect, useState } from 'react';
import useGetSearchColumnProps from '../../../../common/hooks/SearchData';
import { IPermission, ISetState } from '../../../../common/types/commonTypes';
import { useDeleteDepartmentMutation } from '../endpoints/departmentEndpoints';
import { DepartmentDataType } from '../types/departmentTypes';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../auth/states/userSlice';

type Props = {
  setEditInfo: ISetState<DepartmentDataType | null>;
  showModal: () => void;
  permission?: IPermission;
  pagination: {
    current: number;
    pageSize: number;
  };
};

export const columns = ({
  pagination,
  setEditInfo,
  showModal,
  permission,
}: Props): ColumnsType<DepartmentDataType> => {
  const searchColumnProps = useGetSearchColumnProps<DepartmentDataType>();
  const [columnIndex, setColumnIndex] = useState<number | null>(null);

  /**
   * handle click
   */
  const handleClick = (record: DepartmentDataType) => {
    setEditInfo(record);
    showModal();
  };

  /**
   * handle delete
   */
  const [deleteDepartment, { isError, isSuccess, isLoading }] =
    useDeleteDepartmentMutation();
  const user = useSelector(selectUser);
  useEffect(() => {
    if (isSuccess) {
      setColumnIndex(null);
      message.success('Department Deleted Successfully');
    } else if (isError) {
      setColumnIndex(null);
      message.error('Something went wrong');
    }
  }, [isSuccess, isError]);

  const handleDelete = async (values: DepartmentDataType, index: number) => {
    setColumnIndex(index);
    await deleteDepartment({ ...values, deleted_by: user?.user_id });
  };

  return [
    {
      title: 'SL.',
      dataIndex: 'key',
      key: 'serial',
      render: (_, data, index) => (
        <>
          {((pagination.current || 1) - 1) * (pagination.pageSize || 20) +
            1 +
            index}
        </>
      ),
    },
    {
      title: 'Department Name',
      dataIndex: 'department_name',
      key: 'department_name',
    },
    {
      title: 'Action',
      key: 'action',

      render: (_, record, index) => (
        <Space size='small'>
          {permission?.['update:any'] && record.agency_id && (
            <Button
              size='small'
              type='primary'
              onClick={() => handleClick(record)}
            >
              Edit
            </Button>
          )}

          {permission?.['delete:any'] && record.agency_id && (
            <Popconfirm
              title='Sure to delete?'
              onConfirm={() => handleDelete(record, index)}
            >
              <Button
                danger
                size='small'
                type='primary'
                loading={columnIndex === index && true}
              >
                Delete
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];
};
